import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import deliveryMenKeys from '../util/delivery-men-keys';
import {AccessControlProps} from 'modules/access-controls/types';

export interface EditDeliveryManProps extends Omit<AccessControlProps, 'id'> {}

const useEditDeliveryMan = (id: string) => {
  const {update} = useInfiniteQueryHelpers();
  const {setData} = useQueryHelpers();

  const onSuccess = (data: AccessControlProps) => {
    update(deliveryMenKeys.list(), data);
    setData(deliveryMenKeys.details(id), data);
  };

  return useApiMutation<EditDeliveryManProps>({
    url: `/access-controls/${id}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar entregador',
    successTitle: 'Editar entregador',
    successMessage: 'Entregador atualizado com sucesso',
    onSuccess,
  });
};

export default useEditDeliveryMan;
